import {
  CalendarMonth,
  Schedule,
  Settings,
  Badge,
  Waves,
  Category,
  SupervisedUserCircle,
  HourglassBottom,
  AddTask,
  Bolt,
  Block
} from "@mui/icons-material";
import { Box } from "@mui/material";
import { MenuItem } from "./MenuItems";

// The tasks icon with a small superscript icon marking the task variant (recurring, dynamic, ...).
const TaskVariantIcon = ({ superscript }: { superscript: JSX.Element }) => (
  <Box sx={{ position: "relative", display: "inline-flex" }}>
    <AddTask />
    <Box sx={{ position: "absolute", top: -5, right: -16, display: "inline-flex", "& > svg": { fontSize: 16 } }}>
      {superscript}
    </Box>
  </Box>
);

export const settingsMenuItems: MenuItem[] = [
  {
    id: "templates_content",
    name: "Templates",
    icon: <Settings />,
    link: "/templates_content",
    collection: "templates_content",
  },
  {
    id: "schedules",
    name: "Disponibilidades Equipa",
    icon: <CalendarMonth />,
    link: "/schedules",
    collection: "schedules",
  },
  {
    id: "staff-work-logs",
    name: "Registos de horas",
    icon: <Schedule />,
    link: "/staff-work-logs",
    collection: "staff-work-logs",
  },
  {
    id: "staff_agreements",
    name: "Acordos de Trabalho",
    icon: <Badge />,
    link: "/staff_agreements",
    collection: "staff_agreements",
  },
  {
    id: "staff_subjective_evaluation",
    name: "Avaliação de desempenho",
    icon: <SupervisedUserCircle />,
    link: "/staff_subjective_evaluation",
    collection: "staff_subjective_evaluation",
  },
  {
    id: "gaps",
    name: "Gaps",
    icon: <HourglassBottom />,
    link: "/gaps",
    collection: "gap-allocator",
  },
  {
    id: "scheduled_tasks",
    name: "Tarefas Recorrentes",
    icon: <TaskVariantIcon superscript={<Schedule />} />,
    link: "/scheduled_tasks",
    collection: "scheduled_tasks",
  },
  {
    id: "dynamic_tasks",
    name: "Tarefas Dinâmicas",
    icon: <TaskVariantIcon superscript={<Bolt />} />,
    link: "/dynamic_tasks",
    collection: "dynamic_tasks",
  },
  {
    id: "nfb_feedback_types",
    name: "Tipos de feedback de Neurofeedback",
    icon: <Waves />,
    link: "/nfb_feedback_types",
    collection: "nfb_feedback_types",
  },
  {
    id: "clinics_nfb_capacity_blocks",
    name: "Bloqueios de Capacidade NFB",
    icon: <Block />,
    link: "/clinics_nfb_capacity_blocks",
    collection: "clinics_nfb_capacity_blocks",
  },
  {
    id: "processes_parent_category",
    name: "Categorias de Processos",
    icon: <Category />,
    link: "/processes_parent_category",
    collection: "processes_parent_category",
  },
];
